import React from "react";
import { Button } from "@mui/material";

type SubmitResetNavProps = {
  onReset?: () => void;
};

const SubmitResetNav = ({ onReset }: SubmitResetNavProps) => {
  return (
    <>
      <Button type="submit">OK</Button>
      <Button onClick={onReset} type="button">
        Reset
      </Button>
    </>
  );
};

export default SubmitResetNav;
